<ng-container
  *ngIf="cs.vm$ | async as vm"
  [dgxGaContainer]="{ eventCategory: 'checkout option' }"
>
  <h2
    [dgxTestHook]="testHooks.LoggedInCheckoutTitle"
    class="sign-in-form__title"
  >
    {{ vm.cmsData.signInTitle }}
  </h2>
  <p [dgxTestHook]="testHooks.LoggedInCheckoutDescription" class="pb-5">
    {{ vm.cmsData.signInDescription }}
  </p>
  <form
    *ngIf="vm.form as form"
    (submitted)="onFormSubmit($event)"
    [dgxFormDisabled]="vm.userAuthenticating"
    [dgxTestHook]="testHooks.LoggedInCheckoutForm"
    [formGroup]="form"
    class="sign-in-form"
    dgxFormSubmit
    dgxGaFormSubmit
  >
    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="vm.cmsData.signInDetailsForm.emailAddressField"
        [dgxTestHook]="testHooks.LoggedInCheckoutEmailInput"
        [optionalHidden]="true"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="email"
      >
        <dgx-form-email-input [dgxQmSanitise]="'block'" />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row>
      <dgx-form-field
        [dgxFormField]="vm.cmsData.signInDetailsForm.passwordField"
        [dgxTestHook]="testHooks.LoggedInCheckoutPasswordInput"
        [optionalHidden]="true"
        [trackFormField]="'status'"
        dgxGaFormField
        formControlName="password"
      >
        <dgx-form-password-input [dgxQmSanitise]="'block'" />
      </dgx-form-field>
    </dgx-form-row>

    <dgx-form-row>
      <dgx-form-submit-button
        [dgxTestHook]="testHooks.LoggedInCheckoutButton"
        [fill]="true"
        [loading]="vm.userAuthenticating"
      >
        {{ vm.cmsData.signInButtonLabel }}
      </dgx-form-submit-button>
    </dgx-form-row>
  </form>
</ng-container>
